import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { UpsertShareGoal } from './shareGoal.graphql';
import type { UpsertShareGoalMutation, UpsertShareGoalMutationVariables } from './shareGoal.graphql';

export async function saveShareGoal(
	variables: UpsertShareGoalMutationVariables,
	{ gql: { fetch } }: UtilityContext,
): Promise<void> {
	await fetch<UpsertShareGoalMutation, UpsertShareGoalMutationVariables>({
		query: UpsertShareGoal,
		variables,
		rejectOnError: true,
	});
}
